import $ from 'jquery';

$(document).ready(function () {

    $(document).on("FormSectionLoaded", function () {
        resetHasContent("item: document, event: FormSectionLoaded");
    });

    $(document).on("input", "form.bizform .form-control", function () {
        if ($(this).val() !== "") {
            $(this).closest(".form-field").addClass("has-content");
            $(this).addClass("form-control-used");
        } else {
            if ($(this).closest(".form-field").hasClass("has-content"))
                $(this).closest(".form-field").removeClass("has-content");
            if ($(this).hasClass("form-control-used"))
                $(this).removeClass("form-control-used");
        }

        checkRequiredFields("item: form-control, event: input");
    });

    function checkRequiredFields(handlerName) {
        var requiredFieldCount = $("form.bizform .form-field-required").length;
        var requiredFieldsWithContent = $("form.bizform .form-field-required.has-content").length;

        //console.log({ handlerName, requiredFieldCount, requiredFieldsWithContent });

        if (requiredFieldCount > 0 && requiredFieldCount === requiredFieldsWithContent) {
            //console.log("enable submit");
            $("form.bizform input[type='submit']:disabled").removeAttr("disabled");
        } else {
            //console.log("disable submit");
            $("form.bizform input[type='submit']").attr("disabled", "disabled");
        }
    }

    function resetHasContent(handlerName) {

        $("form.bizform textarea.form-control").each(function () {
            if ($(this).val() !== "") {
                $(this).closest(".form-field").addClass("has-content");
                $(this).addClass("form-control-used");
            } else {
                if ($(this).closest(".form-field").hasClass("has-content"))
                    $(this).closest(".form-field").removeClass("has-content");
                if ($(this).hasClass("form-control-used"))
                    $(this).removeClass("form-control-used");
            }
        });

        $("form.bizform input[type=text].form-control").each(function () {
            if ($(this).val() !== "") {
                $(this).closest(".form-field").addClass("has-content");
                $(this).addClass("form-control-used");
            } else {
                if ($(this).closest(".form-field").hasClass("has-content"))
                    $(this).closest(".form-field").removeClass("has-content");
                if ($(this).hasClass("form-control-used"))
                    $(this).removeClass("form-control-used");
            }
        });

        $("form.bizform input[type=radio].form-control").each(function () {
            if ($(this).is(':checked')) {
                $(this).closest(".form-field").addClass("has-content");
            }
        });


        checkRequiredFields(handlerName);
    }

});
